import React from "react";

function DoorPhysical() {
    return (
        <div>
            <h2>Physical Intervention Skills</h2>
            <p>
                Physical intervention should always be a last resort. This module teaches safe, legal, and proportionate techniques for managing physical conflict while minimizing risk to all parties.
            </p>

            <h3>Legal Use of Force</h3>
            <ul>
                <li>Use of force must be <strong>reasonable, necessary, and proportionate</strong></li>
                <li>Guided by the <strong>Criminal Law Act 1967</strong> and <strong>Common Law</strong></li>
                <li>Only use force to prevent crime, protect people, or remove someone posing a threat</li>
                <li>Excessive or unjustified force can lead to prosecution or loss of license</li>
            </ul>

            <h3>Types of Physical Intervention</h3>
            <ul>
                <li><strong>Non-restrictive:</strong> Guiding or prompting someone to move</li>
                <li><strong>Restrictive:</strong> Physically holding or restraining someone</li>
                <li><strong>Disengagement:</strong> Breaking away from grabs or holds</li>
            </ul>

            <h3>Safety Considerations</h3>
            <ul>
                <li>Always work in pairs when possible</li>
                <li>Avoid high-risk techniques (e.g. neck holds, prone restraint)</li>
                <li>Monitor the person’s condition throughout</li>
                <li>Use the minimum force for the shortest time</li>
            </ul>

            <h3>Post-Incident Actions</h3>
            <ul>
                <li>Check for injuries and offer first aid if needed</li>
                <li>Record the incident in detail (who, what, when, where, why)</li>
                <li>Report to management and law enforcement if appropriate</li>
                <li>Reflect on the incident to improve future responses</li>
            </ul>

            <h3>Prohibited Techniques</h3>
            <ul>
                <li>Neck restraints or chokeholds</li>
                <li>Ground restraint (especially face-down)</li>
                <li>Techniques that restrict breathing or circulation</li>
            </ul>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.gov.uk/government/publications/physical-intervention-practice-guidance" target="_blank" rel="noreferrer">UK Gov – Physical Intervention Guidance</a></li>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – Physical Skills Training</a></li>
                <li><a href="https://www.nice.org.uk/guidance/ng10" target="_blank" rel="noreferrer">NICE Guidelines – Violence and Aggression</a></li>
            </ul>
        </div>
    );
}

export default DoorPhysical;
